/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeLanguage } from './CodeLanguage';
import {
    CodeLanguageFromJSON,
    CodeLanguageFromJSONTyped,
    CodeLanguageToJSON,
    CodeLanguageToJSONTyped,
} from './CodeLanguage';
import type { JudgingState } from './JudgingState';
import {
    JudgingStateFromJSON,
    JudgingStateFromJSONTyped,
    JudgingStateToJSON,
    JudgingStateToJSONTyped,
} from './JudgingState';
import type { FeedbackLevel } from './FeedbackLevel';
import {
    FeedbackLevelFromJSON,
    FeedbackLevelFromJSONTyped,
    FeedbackLevelToJSON,
    FeedbackLevelToJSONTyped,
} from './FeedbackLevel';

/**
 * 
 * @export
 * @interface SubmissionRead
 */
export interface SubmissionRead {
    /**
     * 
     * @type {string}
     * @memberof SubmissionRead
     */
    problem_id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionRead
     */
    competitor_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionRead
     */
    code: string;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionRead
     */
    created_at?: Date | null;
    /**
     * 
     * @type {CodeLanguage}
     * @memberof SubmissionRead
     */
    language: CodeLanguage;
    /**
     * 
     * @type {string}
     * @memberof SubmissionRead
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SubmissionRead
     */
    points: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionRead
     */
    user_id: string | null;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof SubmissionRead
     */
    feedback?: FeedbackLevel;
    /**
     * 
     * @type {JudgingState}
     * @memberof SubmissionRead
     */
    judging?: JudgingState | null;
}



/**
 * Check if a given object implements the SubmissionRead interface.
 */
export function instanceOfSubmissionRead(value: object): value is SubmissionRead {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    return true;
}

export function SubmissionReadFromJSON(json: any): SubmissionRead {
    return SubmissionReadFromJSONTyped(json, false);
}

export function SubmissionReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionRead {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'competitor_id': json['competitor_id'] == null ? undefined : json['competitor_id'],
        'code': json['code'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'language': CodeLanguageFromJSON(json['language']),
        'id': json['id'],
        'points': json['points'],
        'user_id': json['user_id'],
        'feedback': json['feedback'] == null ? undefined : FeedbackLevelFromJSON(json['feedback']),
        'judging': json['judging'] == null ? undefined : JudgingStateFromJSON(json['judging']),
    };
}

export function SubmissionReadToJSON(json: any): SubmissionRead {
    return SubmissionReadToJSONTyped(json, false);
}

export function SubmissionReadToJSONTyped(value?: SubmissionRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'competitor_id': value['competitor_id'],
        'code': value['code'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at'] as any).toISOString()),
        'language': CodeLanguageToJSON(value['language']),
        'id': value['id'],
        'points': value['points'],
        'user_id': value['user_id'],
        'feedback': FeedbackLevelToJSON(value['feedback']),
        'judging': JudgingStateToJSON(value['judging']),
    };
}

